import {useCallback} from 'react'

import {RequestStatus} from '@/typedef'
import {useFetchHook} from '@/hooks/useFetch'
import {ISuperAgentResSingle} from '@/api/response-typedf'
import {postEvent} from '@/modules/ITSM/api/eventsRequests'

import {TEvent} from '../typedf'

export function usePostEvent(): {
  readonly saveEntity: (
    data: TEvent,
    id?: string
  ) => Promise<ISuperAgentResSingle<TEvent> | undefined>
  readonly saveEntityStatus: RequestStatus
} {
  const {
    status,
    handleRequested,
    handleSuccess,
    handleFail,
    handleReset,
  } = useFetchHook({
    loadingMessage: 'saving',
    successMessage: 'success',
    errorMessage: 'error',
  })

  const saveEntity = useCallback(
    async (data: TEvent) => {
      try {
        handleRequested()

        const {
          body: {result},
        } = await postEvent(data)
        if (result) {
          handleSuccess()
          return result
        }

        return undefined
      } catch (err) {
        handleFail(err)
      } finally {
        handleReset()
      }
    },
    [handleFail, handleRequested, handleReset, handleSuccess]
  )

  return {
    saveEntity,
    saveEntityStatus: status,
  }
}
